module.exports = flarum.core.compat['components/ModalManager'];